import { render, staticRenderFns } from "./rewards_detail.vue?vue&type=template&id=0ac90b2f&scoped=true&"
import script from "./rewards_detail.vue?vue&type=script&lang=js&"
export * from "./rewards_detail.vue?vue&type=script&lang=js&"
import style0 from "./rewards_detail.vue?vue&type=style&index=0&id=0ac90b2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac90b2f",
  null
  
)

export default component.exports